import IsThresholdEditable from "./isThresholdEditable";
export default (thresholdsProtocol) => (Object.assign(Object.assign({}, thresholdsProtocol), { isThresholdEditable: IsThresholdEditable(thresholdsProtocol) }));
